module.exports = "data:image/png;base64,R0lGODlhAQABAIABAB0waf///ywAAAAAAQABAAACAkQBADs="